<%# Subscribe to real-time photo updates from all users %>
<%= turbo_stream_from "photos" %>

<div class="container mx-auto px-4 py-8" data-controller="camera">
  <h1 class="text-3xl font-bold mb-8">Photo Gallery</h1>

  <!-- Camera controls -->
  <div class="mb-8 p-6 bg-gray-100 rounded-lg">
    <div class="flex gap-4 mb-4">
      <button data-action="click->camera#takePhoto"
              class="bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition">
        Take Photo
      </button>
      <button data-action="click->camera#chooseFromGallery"
              class="bg-gray-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-700 transition">
        Choose from Gallery
      </button>
    </div>

    <!-- Video preview for browser camera -->
    <video data-camera-target="video"
           class="hidden w-full max-w-md rounded-lg mb-4"
           autoplay playsinline></video>

    <!-- Capture button (shown when video is active) -->
    <button data-camera-target="captureBtn"
            data-action="click->camera#capture"
            class="hidden bg-green-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-700 transition mb-4">
      Capture
    </button>

    <!-- New photo form -->
    <%= form_with url: "/photos", method: :post,
                  data: { camera_target: "form", action: "turbo:submit-end->camera#reset" },
                  class: "hidden" do |f| %>
      <input type="hidden" name="photo[image_data]" data-camera-target="imageData">

      <!-- Image preview after capture -->
      <img data-camera-target="preview" class="w-full max-w-md rounded-lg mb-4" />

      <div class="flex gap-4 items-end">
        <input type="text" name="photo[caption]"
               placeholder="Add a caption..."
               data-camera-target="captionInput"
               class="flex-1 border rounded-lg p-3">

        <%= f.submit "Save Photo",
               class: "bg-green-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-green-700 transition cursor-pointer" %>
      </div>
    <% end %>
  </div>

  <!-- Gallery grid -->
  <div id="photos" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
    <%= render @photos %>
    <p id="empty-message" class="text-gray-500 text-center py-12 col-span-full hidden only:block">
      No photos yet. Take one to get started!
    </p>
  </div>
</div>
